import { fetchLocationInfo, LocationInfo } from "../location"

type Props = {
  triggerSelector: string
  targetSelector: string
  linkSelector: string
  activeClass: string
  primaryNumberSelector: string
}

export default function salesToggle(
  el: HTMLElement,
  {
    triggerSelector,
    targetSelector,
    linkSelector,
    activeClass,
    primaryNumberSelector,
  }: Props
) {
  const triggerEl: HTMLButtonElement | null = el.querySelector(triggerSelector)
  const targetEl: HTMLElement | null = el.querySelector(targetSelector)
  const primaryNumber: HTMLElement | null = el.querySelector(
    primaryNumberSelector
  )

  if (triggerEl == null || targetEl == null) {
    return
  }
  const linkEls: NodeListOf<any> | null = targetEl?.querySelectorAll(
    linkSelector
  )

  // Remove `focus-within` capability as JS is active
  targetEl.classList.remove("focus-within:opacity-100")
  targetEl.classList.remove("focus-within:block")

  // Make phone number items initially inaccessible via tabbing
  linkEls.forEach((link: HTMLElement) => {
    link.setAttribute("tabindex", "-1")
  })

  let dropdownIsVisible = false

  // Show/hide the dropdown with click
  triggerEl.addEventListener("click", function () {
    if (dropdownIsVisible === false) {
      showSalesDropdown(el, triggerEl, targetEl, linkEls, activeClass)
      dropdownIsVisible = true
    } else {
      hideSalesDropdown(el, triggerEl, targetEl, linkEls, activeClass)
      dropdownIsVisible = false
    }
  })

  // Hide dropdown with ESC key
  document.addEventListener("keyup", function (e) {
    if (27 === e.keyCode && "Escape" === e.key && dropdownIsVisible === true) {
      hideSalesDropdown(el, triggerEl, targetEl, linkEls, activeClass)
      dropdownIsVisible = false
    } else if (
      9 === e.keyCode &&
      "Tab" === e.key &&
      dropdownIsVisible === true
    ) {
      let focusedEl = document.activeElement
      if (!el.contains(focusedEl)) {
        hideSalesDropdown(el, triggerEl, targetEl, linkEls, activeClass)
      }
    }
  })

  // Hide dropdown if top bar is scrolled beyond of the viewport
  document.addEventListener("scroll", function () {
    // Set a buffer value (in pixels) for hiding the dropdown
    const buffer = 20
    if (dropdownIsVisible === true && window.scrollY > buffer) {
      hideSalesDropdown(el, triggerEl, targetEl, linkEls, activeClass)
      dropdownIsVisible = false
    }
  })

  // Hide dropdown by clicking outside the dropdown element
  window.addEventListener("click", function (e: Event) {
    if (dropdownIsVisible === true) {
      if (!el.contains(e.target as Element)) {
        hideSalesDropdown(el, triggerEl, targetEl, linkEls, activeClass)
        dropdownIsVisible = false
      }
    }
  })

  function setPrimaryInfo(telephone: string, label: string) {
    if (primaryNumber) {
      primaryNumber.innerText = label
      primaryNumber.setAttribute("href", telephone)
    }
  }

  fetchLocationInfo()
    .then(locationInfo => {
      const location: LocationInfo = locationInfo as LocationInfo

      if (location.continent_name) {
        const item = targetEl.querySelector(
          `[data-continent-name="${location.continent_name}"]`
        )

        const itemsToToggle = el.querySelectorAll(
          "[data-phone-number-toggleable]"
        )
        itemsToToggle.forEach(item => {
          let continent = item.getAttribute("data-continent-name")
          if (continent === location.continent_name) {
            item.remove()
          } else {
            item.classList.remove("hidden")
          }
        })

        if (item) {
          const anchorEl = item.querySelector("a")
          if (anchorEl === null) {
            return
          }
          const telephone = anchorEl.getAttribute("href")
          const spanText = anchorEl.querySelector("span")?.innerText

          if (telephone && spanText) {
            setPrimaryInfo(telephone, spanText)
          }
        }
      }

      el.classList.remove("opacity-0")
    })
    .catch(error => {
      el.classList.remove("opacity-0")
    })
}

function showSalesDropdown(
  el: HTMLElement,
  triggerEl: HTMLElement,
  targetEl: HTMLElement,
  linkEls: NodeListOf<HTMLElement>,
  activeClass: string
) {
  el.classList.add(activeClass)
  triggerEl.setAttribute("aria-expanded", "true")
  linkEls.forEach(link => {
    link.removeAttribute("tabindex")
  })
}

function hideSalesDropdown(
  el: HTMLElement,
  triggerEl: HTMLElement,
  targetEl: HTMLElement,
  linkEls: NodeListOf<HTMLElement>,
  activeClass: string
) {
  el.classList.remove(activeClass)
  triggerEl.setAttribute("aria-expanded", "false")
  linkEls.forEach(link => {
    link.setAttribute("tabindex", "-1")
  })
}
